import { cn } from '@shared/utils';
import { Icon } from '@shared/widgets';
import GobblerIcon from '@assets/icons/transactions/gobbler.svg';

interface IAvatarProps {
  className?: string;
}

export const Avatar = (props: IAvatarProps) => {
  return (
    <Icon
      className={cn('border-primary-block-border flex h-10 w-16 items-center justify-center rounded border bg-soft-black', props.className)}
      icon={<GobblerIcon />}
      color='white'
    />
  );
};
